__turbopack_context__.v({
  "actions": "InsoleDetail-module__xk_FTq__actions",
  "badge": "InsoleDetail-module__xk_FTq__badge",
  "badges": "InsoleDetail-module__xk_FTq__badges",
  "detail": "InsoleDetail-module__xk_FTq__detail",
  "name": "InsoleDetail-module__xk_FTq__name",
  "row": "InsoleDetail-module__xk_FTq__row",
});
